class tabbingContent extends HTMLElement {
  constructor() {
    super();
    this.clickEvent();
    this.slideShow();
  }

  clickEvent = () => {
    let tabsButton = qsa('[data-tab-target]', this);
    let tabsContent = qsa('[data-tab-content]', this);

    tabsButton.forEach(tab => {
      tab.addEventListener('click', () => {
        let target = qs(`${tab.dataset.tabTarget}`, this);
        [...tabsButton, ...tabsContent].forEach(tabBtnCont => {
          tabBtnCont.classList.remove('active');
        });

        tab.classList.add('active');
        target.classList.add('active');
      })
    })
  }

  slideShow = () => {
    let multiCollections = qsa("multi-featured-collection-list", this);
    multiCollections.length > 0 && multiCollections.forEach(el => {
      let slidesPerView = parseInt(el.getAttribute('data-rows'));
      let slidesPerViewMob = parseInt(el.getAttribute('data-rows-mob'));

      let options = {
        loop: false,
        slidesPerView: slidesPerView,
        spaceBetween: 20,
        watchSlidesProgress: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        a11y: {
          enabled: true,
          slideRole: 'listitem', // Prevents role="group" on slides
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      };

      if (window.innerWidth > 767 && window.innerWidth < 1025) {
        options['slidesPerView'] = 3;
        options['spaceBetween'] = 20;
      }

      if (window.innerWidth < 768) {
        options['slidesPerView'] = slidesPerViewMob;
        options['spaceBetween'] = 10;
      }

      const swiper = new Swiper(el, options);
      
      
    });
  }
}
customElements.define('tabbing-content', tabbingContent);